const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const AppContext = {
  baseApiUrl: isLocalhost
    ? "http://localhost:9090"
    : "https://fundacioncolegiosantotomas.com.ar",
  /*Familias */
  urlServiceLogin: isLocalhost
    ? "/usuarios/login"
    : "/cst-servicios/usuarios/login",
  urlServiceCta: isLocalhost
    ? "/ctacte/consulta"
    : "/cst-servicios/ctacte/consulta",
  urlServiceFactura: isLocalhost
    ? "/ctacte/consultafactura"
    : "/cst-servicios/ctacte/consultafactura",
  urlServiceAlumno: isLocalhost
    ? "/alumnos/consulta/"
    : "/cst-servicios/alumnos/consulta/",
  urlServiceChangePassword: isLocalhost
    ? "/usuarios/change-password"
    : "/cst-servicios/usuarios/change-password",
  /*Emppleados */
  urlServiceEmpleadoPorCuit: isLocalhost
    ? "/empleados/por-cuit/"
    : "/cst-servicios/empleados/por-cuit/",
  urlServiceLoginEmpleados: isLocalhost
    ? "/empleados/login"
    : "/cst-servicios/empleados/login",
  urlServiceRecibosEmpleado: isLocalhost
    ? "/recibos/empleado/"
    : "/cst-servicios/recibos/empleado/",
  urlServiceReciboDescargar: isLocalhost
    ? "/recibos/descargar/"
    : "/cst-servicios/recibos/descargar/",
  /*Visitas */
  urlServiceVisitas: isLocalhost
    ? "/visitas"
    : "/cst-servicios/visitas",
  urlServiceIncrementarVisitas: isLocalhost
    ? "/visitas/incrementar"
    : "/cst-servicios/visitas/incrementar",
};

export default AppContext;
